import React, { lazy, Suspense } from 'react'
import { css } from '@linaria/core'
import { useTranslation } from 'react-i18next'
import { Link } from '@fs/zion-router'
import { baseUrl, targetEnv } from '@fs/zion-config'
import { i18n } from '@fs/zion-locale'
import { useUser } from '@fs/zion-user'
import logo from '../../img/familysearch-tree.svg'
import betaLogo from '../../img/familysearch-tree-beta.svg'
import grayLogo from '../../img/FSLogo.svg'
import grayBetaLogo from '../../img/grayFSLogo-beta.svg'

const LogoFamilysearch = lazy(() => import('./LogoFamilySearch'))

const logoCss = css`
  display: flex;
  margin-bottom: 2px;
  align-items: center;
`

export function isBetaEnvironment({ env = targetEnv, url = baseUrl } = {}) {
  return env === 'beta' || (typeof url === 'string' && url.includes('beta.familysearch.org'))
}

export function getLogoVariant({ gray, isBeta }) {
  if (gray) {
    return isBeta ? grayBetaLogo : grayLogo
  }

  if (isBeta) {
    return betaLogo
  }

  return logo
}

export function Logo({ breakMode, signedIn, gray, isBetaEnvironmentOverride }) {
  const { t } = useTranslation()
  const alt = t('global.familysearch', 'FamilySearch')
  const isBeta = isBetaEnvironmentOverride ?? isBetaEnvironment()
  const logoSrc = getLogoVariant({ gray, isBeta })

  return (
    <div className={logoCss}>
      <Suspense fallback="">
        {breakMode === 'mobile' && signedIn === true ? (
          <LogoFamilysearch size="md" role="img" alt={alt} aria-label={alt} />
        ) : (
          <img src={logoSrc} width="132" height="33.8" alt={alt} aria-label={alt} data-test-id="hdr_FS_logo" />
        )}
      </Suspense>
    </div>
  )
}

export default function FSLogo({ useBaseUrl = false, ...props }) {
  const { t } = useTranslation()
  const ariaLabel = props['aria-label'] || t('header.logo-link-aria-label', 'FamilySearch Home')
  const { signedIn } = useUser()
  const homeBaseUrl = useBaseUrl && baseUrl ? baseUrl : ''
  const signedOutURL = `${homeBaseUrl}/${i18n.language}/`
  const signedInURL = `${homeBaseUrl}/${i18n.language}/home/portal/`
  return (
    <Link
      to={signedIn ? signedInURL : signedOutURL}
      linkName="hdr19_home_logo"
      external
      className={logoCss}
      aria-label={ariaLabel}
    >
      <Logo {...props} />
    </Link>
  )
}
